import { useWorkerStore } from '../store/workerStore'
import './EmployeeDeletedScreen.css'

/**
 * Экран, показываемый когда сотрудник был удален администратором
 */
export function EmployeeDeletedScreen() {
  const { reset } = useWorkerStore()
  
  const handleReset = () => {
    reset()
    // Перезагружаем страницу для возврата на онбординг
    window.location.href = '/'
  }
  
  return (
    <div className="employee-deleted-container">
      <div className="employee-deleted-content">
        <div className="employee-deleted-icon">⚠️</div>
        
        <h1 className="employee-deleted-title">Приложение сброшено</h1>
        
        <p className="employee-deleted-message">
          Ваша учетная запись была удалена администратором.
          Для продолжения работы необходимо пройти регистрацию заново.
        </p>
        
        <button 
          className="employee-deleted-button"
          onClick={handleReset}
        >
          Вернуться к регистрации
        </button>
      </div>
    </div>
  )
}
